import { render, staticRenderFns } from "./FrontPostHalfDoubleCrochetIcon.vue?vue&type=template&id=ef255ef4&scoped=true"
import script from "./FrontPostHalfDoubleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./FrontPostHalfDoubleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./FrontPostHalfDoubleCrochetIcon.vue?vue&type=style&index=0&id=ef255ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef255ef4",
  null
  
)

export default component.exports